'use client';

import { appConfig } from '@/config';
import { notFound } from 'next/navigation';
import { FormEvent, useEffect, useState } from 'react';

const credintials = {
  username: 'er3m',
  password: 'er3m'
}
export default function Login() {


  const [state, setState] = useState({auth: true, username: '', password: '', error: ''});

useEffect(() => {
  try {
    const auth = localStorage.getItem('authenticated') === 'true';
    setState(prev => ({ ...prev, auth }));
  } catch {
    setState(prev => ({ ...prev, auth: false }));
  }
}, []);

  async function submit(e: FormEvent) {
    e.preventDefault();

    if (state.username === credintials.username && state.password === credintials.password) {
      setState(prev => ({...prev, error: '', auth: true}));
      try {

        localStorage.setItem('authenticated', 'true');
      } catch(err) {
        
      }
    } else {
      setState(prev => ({...prev, error: 'Invalid password'}));
    }
  }

  if (state.auth) return null;


  // if (!appConfig.requiresLogin) return notFound();

  return (
    <div className='h-full w-full grid place-items-center px-[24px] fixed top-0 left-0 z-[1000000] bg-white login-page' dir='ltr'>
    <form onSubmit={submit} className='flex flex-col gap-[24px] w-full max-w-[400px] h-fit p-[24px] border border-gray-300 rounded-[12px]'>
      <span className='text-[20px] text-center font-bold'>Login</span>
      <div className='flex flex-col gap-[5px]'>
        <span>Username</span>
        <div className='border border-gray-300 rounded-[6px] w-full p-[12px]'>
          <input
            value={state.username}
            onChange={({target: {value}}) => setState(prev => ({...prev, username: value, error: ''}))}
            autoFocus
            className='bg-transparent outline-none border-none w-full h-full'
            />
            </div>
        </div>
        <div className='flex flex-col gap-[5px]'>
        <span>Password</span>
        <div className='border border-gray-300 rounded-[6px] w-full p-[12px]'>
      <input
        type='password'
        value={state.password}
        onChange={({target: {value}}) => setState(prev => ({...prev, password: value, error: ''}))}
        className='bg-transparent outline-none border-none w-full h-full'
      />
      </div>
      </div>
      {state.error && <span className='text-danger'>{state.error}</span>}
      <button type="submit" className='bg-primary text-white rounded-[12px] p-[12px] disabled:opacity-40 disabled:cursor-not-allowed' disabled={!state.username || !state.password}>Login</button>
    </form>
    </div>
  );
}